export default __webpack_public_path__ + "static/media/Screenshot_1619919038.3816fdf7.png";